export default from './share-button';



// WEBPACK FOOTER //
// ./app/components/share-button/index.js